var render, staticRenderFns
import script from "./customMenu.vue?vue&type=script&lang=js&"
export * from "./customMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f85492",
  null
  
)

export default component.exports